<template>
  <div class="radar-chart-component">
    <chart :options="options"></chart>
  </div>
</template>

<script>
  export default {
    name: 'RadarChart',
    props: {
      resultList: {
        type: Array,
        required: true,
      },
    },
    data() {
      return {
        options: {
          title: {
            text: '自定义雷达图',
          },
          legend: {
            data: ['图一', '图二', '张三', '李四'],
          },
          radar: [
            {
              indicator: [
                { text: '认知领域', max: 5, color: '#515163' },
                { text: '动机情感领域', max: 5, color: '#515163' },
                { text: '任务领域', max: 5, color: '#515163' },
                { text: '环境领域', max: 5, color: '#515163' },
                { text: '时间领域', max: 5, color: '#515163' },
                { text: '求助资源领域', max: 5, color: '#515163' },
              ],
              center: ['50%', '58%'],
              radius: '63%',
              startAngle: 90,
              splitNumber: 5,
              shape: 'circle',
              name: {
                formatter: '{value}',
                textStyle: {
                  color: '#72ACD1',
                },
              },
              splitArea: {
                areaStyle: {
                  color: [
                    '#a6a9ef',
                    '#bbbdf3',
                    '#d0d2fa',
                    '#e8e9ff',
                    '#ffffff',
                  ],
                },
              },
              axisLine: {
                lineStyle: {
                  color: 'rgba(255, 255, 255, 0.5)',
                },
              },
              splitLine: {
                lineStyle: {
                  color: 'rgba(255, 255, 255, 0.5)',
                },
              },
            },
          ],
          series: [
            {
              name: '雷达图',
              type: 'radar',
              emphasis: {
                lineStyle: {
                  width: 4,
                },
              },
              data: [
                {
                  value: this.resultList,
                  name: '图二',
                  areaStyle: {
                    color: 'rgba(255, 191, 19, 0.8)',
                  },
                  itemStyle: {
                    color: 'white',
                  },
                  lineStyle: {
                  },
                },
              ],
            },
          ],
        },
      };
    },
  };
</script>

<style scoped lang="less">
  .radar-chart-component {
    width: 700px;
    height: 500px;
    display: flex;
    align-items: center;
    justify-content: center;
    /deep/ .echarts {
      width: 700px;
      height: 500px;
    }
  }

</style>
